import request from '@/api/request'

export default {
  async getVariationTemplate () {
    return (await request.get(`module/action/ecommerce/ecomece/variation_template`)).data
  },
  async getSpecifications () {
    return (await request.get(`module/action/ecommerce/ecomece/specification`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/ecommerce/ecomece/index.js